const pageNameKey = "otaBackupProcessRequestApprovalForAdmin";

export const otaBackupProcessRequestApprovalForAdminEn = {
  [pageNameKey]: {
    title: "Backup Process Request for Approval",
    descriptionTemplate:
      "The Technician {username} requests to create a backup of this machine.",
    reviewAndApproveButtonText: "Review Request and Approve",
    cancelRequestButtonText: "Cancel Request",
    cancelSuccessMessage: "Backup request canceled successfully",
    cancelFailureMessage: "Failed to cancel backup request",
  },
};

export const otaBackupProcessRequestApprovalForAdminPtBr = {
  [pageNameKey]: {
    title: "Solicitação de aprovação do processo de backup",
    descriptionTemplate:
      "O técnico {username} solicita criar um backup desta máquina.",
    reviewAndApproveButtonText: "Revisar solicitação e aprovar",
    cancelRequestButtonText: "Cancelar solicitação",
    cancelSuccessMessage: "Solicitação de backup cancelada com sucesso",
    cancelFailureMessage: "Falha ao cancelar a solicitação de backup",
  },
};

export const otaBackupProcessRequestApprovalForAdminDe = {
  [pageNameKey]: {
    title: "Backup-Prozess: Anfrage zur Genehmigung",
    descriptionTemplate:
      "Der Techniker {username} beantragt, ein Backup dieser Maschine zu erstellen.",
    reviewAndApproveButtonText: "Anfrage prüfen und genehmigen",
    cancelRequestButtonText: "Anfrage abbrechen",
    cancelSuccessMessage: "Backup-Anfrage erfolgreich abgebrochen",
    cancelFailureMessage: "Backup-Anfrage konnte nicht abgebrochen werden",
  },
};

export const otaBackupProcessRequestApprovalForAdminZhHans = {
  [pageNameKey]: {
    title: "备份流程请求批准",
    descriptionTemplate: "技术员 {username} 请求为此设备创建备份。",
    reviewAndApproveButtonText: "审核请求并批准",
    cancelRequestButtonText: "取消请求",
    cancelSuccessMessage: "备份请求已成功取消",
    cancelFailureMessage: "取消备份请求失败",
  },
};

export const otaBackupProcessRequestApprovalForAdminIt = {
  [pageNameKey]: {
    title: "Richiesta di approvazione del processo di backup",
    descriptionTemplate:
      "Il tecnico {username} richiede di creare un backup di questa macchina.",
    reviewAndApproveButtonText: "Rivedi richiesta e approva",
    cancelRequestButtonText: "Annulla richiesta",
    cancelSuccessMessage: "Richiesta di backup annullata con successo",
    cancelFailureMessage: "Impossibile annullare la richiesta di backup",
  },
};

export const otaBackupProcessRequestApprovalForAdminEs = {
  [pageNameKey]: {
    title: "Solicitud de aprobación del proceso de respaldo",
    descriptionTemplate:
      "El técnico {username} solicita crear un respaldo de esta máquina.",
    reviewAndApproveButtonText: "Revisar solicitud y aprobar",
    cancelRequestButtonText: "Cancelar solicitud",
    cancelSuccessMessage: "Solicitud de respaldo cancelada correctamente",
    cancelFailureMessage: "No se pudo cancelar la solicitud de respaldo",
  },
};

export const otaBackupProcessRequestApprovalForAdminNl = {
  [pageNameKey]: {
    title: "Back-upproces: verzoek om goedkeuring",
    descriptionTemplate:
      "De technicus {username} vraagt om een back-up van deze machine te maken.",
    reviewAndApproveButtonText: "Verzoek beoordelen en goedkeuren",
    cancelRequestButtonText: "Verzoek annuleren",
    cancelSuccessMessage: "Back-upverzoek succesvol geannuleerd",
    cancelFailureMessage: "Back-upverzoek kon niet worden geannuleerd",
  },
};

export const otaBackupProcessRequestApprovalForAdminTr = {
  [pageNameKey]: {
    title: "Yedekleme İşlemi Onay Talebi",
    descriptionTemplate:
      "Teknisyen {username} bu makinenin bir yedeğini oluşturmayı talep ediyor.",
    reviewAndApproveButtonText: "İsteği İncele ve Onayla",
    cancelRequestButtonText: "İsteği İptal Et",
    cancelSuccessMessage: "Yedekleme isteği başarıyla iptal edildi",
    cancelFailureMessage: "Yedekleme isteği iptal edilemedi",
  },
};
